<div class="chat-dialog__backdrop" (click)="closed.emit()"></div>

<div class="chat-dialog" role="dialog" aria-modal="true" [attr.aria-label]="title">
  <header class="chat-dialog__header">
    <h3>{{ title }}</h3>
    <button type="button" (click)="closed.emit()" aria-label="Close"><i class="pi pi-times"></i></button>
  </header>

  <!-- CREATE ------------------------------------------------------------------->
  <div class="chat-dialog__body" *ngIf="mode === 'create'">
    <label class="chat-dialog__field">
      <span>Group Name</span>
      <input type="text" [(ngModel)]="name" placeholder="e.g. Sales Team" maxlength="60" />
    </label>

    <div class="chat-dialog__picker">
      <div class="chat-dialog__column">
        <span class="chat-dialog__column-title">Add Members</span>
        <div class="chat-dialog__search">
          <i class="pi pi-search"></i>
          <input type="text" [(ngModel)]="search" placeholder="Search people…" />
        </div>

        <p class="chat-dialog__loading" *ngIf="loading"><i class="pi pi-spin pi-spinner"></i> Loading your office…</p>

        <ul class="chat-dialog__people">
          <li *ngFor="let person of selectablePeople; trackBy: trackByPerson" (click)="toggle(person)" [class.is-selected]="isSelected(person)">
            <span class="chat-dialog__check" [class.is-on]="isSelected(person)"><i class="pi pi-check" *ngIf="isSelected(person)"></i></span>
            <app-chat-avatar [name]="person.name" [avatar]="person.avatar_url" [status]="person.status" [size]="28"></app-chat-avatar>
            <span class="chat-dialog__person-name">{{ person.name }}</span>
          </li>
          <li class="chat-dialog__none" *ngIf="!loading && !selectablePeople.length">No matching people.</li>
        </ul>
      </div>

      <div class="chat-dialog__column">
        <span class="chat-dialog__column-title">Selected ({{ selectedIds.size }})</span>
        <ul class="chat-dialog__selected">
          <li *ngFor="let person of selected; trackBy: trackByPerson">
            <app-chat-avatar [name]="person.name" [avatar]="person.avatar_url" [size]="24"></app-chat-avatar>
            <span>{{ person.name }}</span>
            <button type="button" (click)="toggle(person)" [attr.aria-label]="'Remove ' + person.name"><i class="pi pi-times"></i></button>
          </li>
          <li class="chat-dialog__none" *ngIf="!selectedIds.size">Pick at least one person.</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- MANAGE ------------------------------------------------------------------->
  <div class="chat-dialog__body chat-dialog__body--tabbed" *ngIf="mode === 'manage' && group">
    <nav class="chat-dialog__tabs">
      <button type="button" [class.is-active]="tab === 'details'" (click)="tab = 'details'">Group Details</button>
      <button type="button" [class.is-active]="tab === 'members'" (click)="tab = 'members'">Members ({{ group.members.length }})</button>
      <button type="button" [class.is-active]="tab === 'settings'" (click)="tab = 'settings'">Settings</button>
    </nav>

    <div class="chat-dialog__tab-body">
      <!-- Details -->
      <ng-container *ngIf="tab === 'details'">
        <label class="chat-dialog__field">
          <span>Group Name</span>
          <div class="chat-dialog__inline">
            <input type="text" [(ngModel)]="name" maxlength="60" />
            <button type="button" class="chat-dialog__primary" (click)="saveName()" [disabled]="!name.trim() || name.trim() === group.name">
              Save
            </button>
          </div>
        </label>

        <div class="chat-dialog__meta" *ngIf="group.created_by">
          <span class="chat-dialog__label">Created by</span>
          <div class="chat-dialog__creator">
            <app-chat-avatar [name]="group.created_by.name" [size]="28"></app-chat-avatar>
            <div>
              <strong>{{ group.created_by.name }}</strong>
              <small>Created on {{ dayLabel(group.created_at) }}</small>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Members -->
      <ng-container *ngIf="tab === 'members'">
        <span class="chat-dialog__label">Current members</span>
        <ul class="chat-dialog__selected chat-dialog__selected--tall">
          <li *ngFor="let member of group.members">
            <app-chat-avatar [name]="member.name" [avatar]="member.avatar_url" [status]="member.status" [size]="26"></app-chat-avatar>
            <span>
              {{ member.name }}
              <em *ngIf="member.role === 'owner'">· Group Admin</em>
            </span>
            <button
              type="button"
              *ngIf="!isMe(member.user_id)"
              (click)="removeMember(member.user_id, member.name)"
              [attr.aria-label]="'Remove ' + member.name">
              <i class="pi pi-times"></i>
            </button>
          </li>
        </ul>

        <span class="chat-dialog__label">Add more people</span>
        <div class="chat-dialog__search">
          <i class="pi pi-search"></i>
          <input type="text" [(ngModel)]="search" placeholder="Search people…" />
        </div>
        <ul class="chat-dialog__people chat-dialog__people--short">
          <li *ngFor="let person of selectablePeople; trackBy: trackByPerson" (click)="toggle(person)" [class.is-selected]="isSelected(person)">
            <span class="chat-dialog__check" [class.is-on]="isSelected(person)"><i class="pi pi-check" *ngIf="isSelected(person)"></i></span>
            <app-chat-avatar [name]="person.name" [avatar]="person.avatar_url" [status]="person.status" [size]="26"></app-chat-avatar>
            <span class="chat-dialog__person-name">{{ person.name }}</span>
          </li>
          <li class="chat-dialog__none" *ngIf="!selectablePeople.length">Everyone in your office is already here.</li>
        </ul>
      </ng-container>

      <!-- Settings -->
      <ng-container *ngIf="tab === 'settings'">
        <div class="chat-dialog__setting">
          <div>
            <strong>Copy Group</strong>
            <small>Create a copy of this group with the same members. Messages aren't copied.</small>
          </div>
          <button type="button" class="chat-dialog__secondary" (click)="copyGroup()">Copy Group</button>
        </div>

        <!-- Also offered by the Group Info panel; both surfaces have to agree on what is possible. -->
        <div class="chat-dialog__setting">
          <div>
            <strong>Leave Group</strong>
            <small>You'll stop receiving its messages. As the owner, it passes to the longest-standing member.</small>
          </div>
          <button type="button" class="chat-dialog__secondary" (click)="leaveGroup()">Leave Group</button>
        </div>

        <div class="chat-dialog__setting">
          <div>
            <strong>Delete Group</strong>
            <small>Permanently delete this group for everyone.</small>
          </div>
          <button type="button" class="chat-dialog__danger" (click)="deleteGroup()">Delete Group</button>
        </div>
      </ng-container>
    </div>
  </div>

  <footer class="chat-dialog__footer">
    <button type="button" class="chat-dialog__secondary" (click)="closed.emit()">{{ mode === 'create' ? 'Cancel' : 'Close' }}</button>
    <button type="button" class="chat-dialog__primary" *ngIf="mode === 'create'" (click)="create()" [disabled]="!canCreate">Create Group</button>
    <button
      type="button"
      class="chat-dialog__primary"
      *ngIf="mode === 'manage' && tab === 'members'"
      (click)="addSelected()"
      [disabled]="!selectedIds.size">
      Add {{ selectedIds.size || '' }} member{{ selectedIds.size === 1 ? '' : 's' }}
    </button>
  </footer>
</div>
